import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins} from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const TRANSIT_STOP_LAYER_ID = 'transitStopLayer';

export const CATEGORY_COLORS = {
  Parcel: [0, 100, 214],
};

const layerConfig = {
  title: 'Transt Stop Layer',
};

function TransitStopLayer() {
  const dispatch = useDispatch();
  const { transitStopLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>  selectSourceById(state, transitStopLayer?.source));
  const cartoLayerProps = useCartoLayerProps({ source });

  const viewState = useSelector((state) => state.carto.viewState);
  let pointRadiusMinPixels;
  let strokedPoint;
  if (viewState.zoom >= 20) {
    pointRadiusMinPixels = 20;
    strokedPoint = true;
  } else if (viewState.zoom >= 16) {
    pointRadiusMinPixels = 16;
    strokedPoint = true;
  } else if (viewState.zoom >= 10) {
    pointRadiusMinPixels = 6;
    strokedPoint = false;
  } else if (viewState.zoom >= 7) {
    pointRadiusMinPixels = 4;
    strokedPoint = false;
  } else {
    pointRadiusMinPixels = 2;
    strokedPoint = false;
  }

  if (transitStopLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: TRANSIT_STOP_LAYER_ID,

      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      stroked: strokedPoint,
      visible: transitStopLayer.visible,
      opacity: transitStopLayer.opacity,
      getFillColor: colorBins({
        attr: 'Transit_Prioritization_Score',
        domain: [0., 3., 4., 5., 6., 10.],
        colors: [
          [249, 144, 6, 0],
          [249, 144, 6, 64],
          [249, 144, 6, 128],
          [249, 144, 6, 192],
          [249, 144, 6, 255],
        ],
      }),
      pointRadiusMinPixels: pointRadiusMinPixels,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: TRANSIT_STOP_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },
       onHover: (info) => {
              if (info?.object) {
                info.object = {
                  html: htmlForFeature({
                    feature: info.object,
                    includeColumns: ['Stop_ID', 'Stop_Name', 'Transit_Agency', 'Stop_Type', 'Route_Names', 'Postmile', 'Walkability_Score', 'Replica_Transit_Demand_Score', 'Daily_Trips', 'Transit_Prioritization_Score']
                  }),
                };
              }
            },

    });
  }
}

export default TransitStopLayer;
